import Modal from "components/DesignSystem/Modal/Modal";
import { AddTransactionManuallyModal } from "components/Transaction/AddTransaction/AddTransactionManuallyModal";

type AddTransactionManuallyProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedAccountId: string;
};

export const AddTransactionManually = ({
  isOpen,
  onClose,
  selectedAccountId,
}: AddTransactionManuallyProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content size="xxl" useCustomOverlay>
        <Modal.Header>
          <Modal.Title>Add transaction manually</Modal.Title>
          <Modal.Close type="button" />
        </Modal.Header>
        <AddTransactionManuallyModal
          close={onClose}
          selectedAccountId={selectedAccountId}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
